import { Link } from 'react-router-dom';
import type { BlogPost } from '../../types/blog';
import { format } from 'date-fns';
import { zhCN } from 'date-fns/locale';

interface BlogCardProps {
  post: BlogPost;
}

export default function BlogCard({ post }: BlogCardProps) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="card-neubrutal bg-white p-6 rounded-lg block"
    >
      {post.coverImage && (
        <div className="aspect-video mb-4 bg-gradient-to-br from-secondary/20 to-primary/20 border-2 border-black rounded-lg flex items-center justify-center overflow-hidden">
          <span className="text-6xl">📝</span>
        </div>
      )}
      <h3 className="text-2xl font-heading font-bold mb-2">
        {post.title}
      </h3>
      <p className="text-sm text-gray-500 mb-3">
        {format(new Date(post.date), 'yyyy年MM月dd日', { locale: zhCN })}
      </p>
      <p className="text-gray-600 mb-4 line-clamp-3">
        {post.excerpt}
      </p>
      <div className="flex flex-wrap gap-2 mb-4">
        {post.tags.map((tag) => (
          <span
            key={tag}
            className="text-xs px-2 py-1 border-2 border-black bg-primary text-white rounded-full"
          >
            {tag}
          </span>
        ))}
      </div>
      <span className="text-cta font-medium inline-block">
        阅读更多 →
      </span>
    </Link>
  );
}
